
import React, { useEffect, useState } from 'react';
import {
    Grid
} from '@mui/material';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import HelpIcon from '@mui/icons-material/Help';
import ReactTooltip from 'react-tooltip';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const classes = {
    lblGraph: {
        backgroundColor: '#F5F5F5',
        color: '#155BCB',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: 3,
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        padding: 10
    },
    graph: {
        border: '1px solid #D1CCCC',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        height: '300px'
    },
    gridLabel: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 5
    },
    helpText: {
        marginTop: -4,
        cursor: 'pointer'
    }
}


export default function EndOfOccurrences({ occurrences, months }) {

    const [dataBar, setDataBar] = useState({
        labels: [],
        datasets: [],
    })

    const optionsYStackbar = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };


    useEffect(() => {
        const labels = months.reduce((array, month) => {
            if (month.isActive)
                array.push(month.name);
            return array;
        }, []);

        //Cada item dos vetores representa um mês.
        const data = {
            'Dentro do Prazo': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            'Fora do Prazo': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }

        for (let i = 0, n = occurrences.length; i < n; i++) {
            const occurrence = occurrences[i];
            const updatedAt = moment(occurrence.updatedAt);

            if (
                occurrence.status === 'Resolvido' &&
                occurrence.datePrevision &&
                moment(occurrence.datePrevision).isSameOrBefore(updatedAt)
            )
                data['Dentro do Prazo'][updatedAt.get('month')] += 1;
            else
                data['Fora do Prazo'][updatedAt.get('month')] += 1;


        }

        //Remove os meses não selecionados
        const dataFiltred = {
            'Dentro do Prazo': [],
            'Fora do Prazo': []
        };

        const monthsNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

        for (let i = 0; i < 12; i++) {
            if (labels.includes(monthsNames[i])) {
                dataFiltred['Dentro do Prazo'].push(data['Dentro do Prazo'][i]);
                dataFiltred['Fora do Prazo'].push(data['Fora do Prazo'][i]);
            }
        }


        setDataBar({
            labels,
            datasets: [
                {
                    label: 'Dentro do Prazo',
                    data: dataFiltred['Dentro do Prazo'],
                    backgroundColor: '#a7db64',
                },
                {
                    label: 'Fora do Prazo',
                    data: dataFiltred['Fora do Prazo'],
                    backgroundColor: '#f24822',
                }
            ],
        })

    }, [occurrences, months]);


    return (
        <div id="end-ocurrencies-dashboard" style={{ width: "100%" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.lblGraph}>
                <div style={classes.gridLabel}>
                    <div>
                        Encerramento de Ocorrência:
                    </div>
                    <div style={classes.helpText}>
                        <ReactTooltip id="proportion-info" className='popup' />
                        <HelpIcon style={{ 'color': '#a1a5ab' }} fontSize="small" data-for="proportion-info" data-place="bottom" data-tip='Gráfico que apresenta a relação entre as ocorrências que foram antendidas dentro e fora do prazo;' />
                    </div>
                </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.graph}>
                <Bar
                    data={dataBar}
                    options={optionsYStackbar}
                />
            </Grid>
        </div>

    )
}